import { useEffect } from "react";
import { useUiStore } from "@/stores/ui";
import { isPushSupported, subscribeWebPush } from "@/lib/push";

/**
 * Mantém a inscrição Web Push sincronizada quando o usuário já aceitou alertas.
 * Garante que o backend tenha o endpoint mesmo após trocar de dispositivo/browser cache.
 */
export function PushSubscriptionSync() {
  const notificationsEnabled = useUiStore((s) => s.notificationsEnabled);

  useEffect(() => {
    if (!notificationsEnabled || !isPushSupported()) return;
    if (typeof Notification === "undefined" || Notification.permission !== "granted") return;

    void subscribeWebPush();
  }, [notificationsEnabled]);

  return null;
}
